<template>
  <div class="container">
    <h2>{{ t('rules.title') }}</h2>

    <div class="rules-content card">
      <section class="rule-section">
        <h3>{{ t('rules.overview.title') }}</h3>
        <p>{{ t('rules.overview.description') }}</p>
      </section>

      <section class="rule-section">
        <h3>{{ t('rules.setup.title') }}</h3>
        <div v-html="t('rules.setup.content')"></div>
      </section>

      <section class="rule-section">
        <h3>{{ t('rules.gameplay.title') }}</h3>
        <div v-html="t('rules.gameplay.content')"></div>
      </section>

      <section class="rule-section">
        <h3>{{ t('rules.winning.title') }}</h3>
        <div v-html="t('rules.winning.content')"></div>
      </section>

      <section class="rule-section">
        <h3>{{ t('rules.abilities.title') }}</h3>
        <div v-html="t('rules.abilities.content')"></div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>
.rules-content {
  max-width: 800px;
  margin: 0 auto;
}

.rule-section {
  margin-bottom: var(--spacing-xl);
  padding-bottom: var(--spacing-xl);
  border-bottom: 1px solid var(--color-bg-tertiary);
}

.rule-section:last-child {
  border-bottom: none;
}

.rule-section h3 {
  color: var(--color-accent-gold);
  margin-bottom: var(--spacing-md);
  font-size: 1.5rem;
}

.rule-section p,
.rule-section :deep(p) {
  color: var(--color-text-secondary);
  line-height: 1.8;
  margin-bottom: var(--spacing-md);
}

.rule-section :deep(ul),
.rule-section :deep(ol) {
  color: var(--color-text-secondary);
  padding-left: var(--spacing-lg);
  margin-bottom: var(--spacing-md);
}

.rule-section :deep(li) {
  margin-bottom: var(--spacing-sm);
  line-height: 1.6;
}

.rule-section :deep(strong) {
  color: var(--color-accent-gold);
}
</style>
